import { BaseEntity } from "app/core/models/base-entity.model";

export class InsuredNotification extends BaseEntity {
    dtCreatedString: string;
    title: string;
    typeId: number;

}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/model/insuredNotification.ts